<template>
    <div class="figureGarden">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px" label-position='right'>
          <el-form-item label="视频资料：">
              <!-- {{'form.video  '+form.video}} -->
              <single-upload v-model="form.video"
                             :isImg="false"

                             :typeArray="['mp4','png']"
                             :listType="String('text')"
                             :sizetxt='String("mp4,不超过100M,最多1个")'>
              ></single-upload>
          </el-form-item>

          <el-form-item label="网站地址：">
            <el-input v-model="form.webAddress" class="webCless"></el-input>
          </el-form-item>

          <el-form-item label="缩略图：">
             <multi-upload v-model="figureList"
                :keyid="figureList"
                :imgWidth='1200'
                :imgHeight='800'
                :typeArray="['png']"
                :maxCount='1'
                :sizetxt='String("建议像素950*530,PNG，不超过10M,最多1张")'>
              </multi-upload>
          </el-form-item>
        </el-form>
    </div>
</template>

<script>
import MultiUpload from '../../../components/multiUpload.vue'
import SingleUpload from '../../../components/singleUpload.vue'
export default {
  name: 'figureGarden',
  props: {

  },
  components: {
    MultiUpload,
    SingleUpload

  },
  data () {
    return {
      figureList: [],
      figureVideoList: [],
      form: {
        webAddress: '' // 网站地址
      },
      rules: {

      }
    }
  },
  computed: {

  },
  created () {
    this.getGardenBaseInfo()
    // this.preview()
  },
  mounted () {
    this.$parent.activeIndex = '7'

    this.$eventBus.$on('surverSave', () => {
      console.log('数字园区信息事件')
      this.figureInfo()
    })
  },
  beforeDestroy () {
    this.$eventBus.$off('surverSave')
  },
  methods: {

    // test (data) {
    //   console.log(data)

    //   // console.log('test')
    // },
    // 初始化园区信息
    async getGardenBaseInfo () {
      try {
        const res = await this.$get(this.$url.gardenInfoManage.gardenBaseInfo)

        const { code, msg, data } = res.data
        if (code === 200) {
          this.form.webAddress = data.extra.website ? data.extra.website : null // 网站地址
          this.figureList = data.extra.thumbnail ? data.extra.thumbnail.split(',') : null // 缩略图
          this.form.video = data.extra.video

          // // console.log(this.figureVideoList)
          // var detailData = JSON.parse(sessionStorage.getItem('gardenDataFigureView'))
          // // console.log(detailData)
          // const previewData = {
          //   website: detailData.website ? detailData.website : null, // 网站地址
          //   thumbnail: detailData.thumbnail ? detailData.thumbnail : null, // 缩略图
          //   video: this.figureVideoList[0]
          // }
          // sessionStorage.setItem('gardenDataFigureView', JSON.stringify(previewData))
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // // 保存数据
    // async saveGarenInfo6 () {
    //   console.log(this.figureVideoList)
    //   const res = await this.$post(this.$url.gardenInfoManage.gardenUpLoadInfo, {
    //     website: this.form.webAddress ? this.form.webAddress : '', // 网站地址
    //     thumbnail: this.figureList ? this.figureList.join(',') : '', // 缩略图
    //     // video: this.figureVideoList.url // 视频资料
    //     video: this.form.video// 视频资料
    //   })
    //   const { code, msg } = res.data

    //   if (code === 200) {
    //     this.$emit('updata', code)
    //     // this.$message.success('保存成功!')
    //     console.log('保存成功!')
    //   } else {
    //     this.$message.error(msg)
    //   }
    // }

    // 数字园区本地保存数据
    figureInfo () {
      const SfigureInfo = {
        website: this.form.webAddress ? this.form.webAddress : '', // 网站地址
        thumbnail: this.figureList ? this.figureList.join(',') : '', // 缩略图
        video: this.form.video// 视频资料
      }
      sessionStorage.setItem('LfigureInfo', JSON.stringify(SfigureInfo))
    }

    // // 预览
    // preview () {
    //   console.log('嘿嘿嘿嘿嘿')
    //   if (this.figureVideoList.constructor === Array) {
    //     const previewData = {
    //       website: this.form.webAddress, // 网站地址
    //       thumbnail: this.figureList.join(','), // 缩略图
    //       video: this.form.video
    //     }
    //     sessionStorage.setItem('gardenDataFigureView', JSON.stringify(previewData))
    //   } else {
    //     const previewData = {
    //       website: this.form.webAddress, // 网站地址
    //       thumbnail: this.figureList.join(','), // 缩略图
    //       video: this.form.video
    //     }
    //     sessionStorage.setItem('gardenDataFigureView', JSON.stringify(previewData))
    //   }
    //   // if (this.figureVideoList.url !== '' && this.figureVideoList.url !== undefined && this.figureVideoList.url !== null) {
    //   // }
    // }
  }
}
</script>

<style scoped lang="less">
.webCless{
  width: 600px;
}
</style>
